import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "./containers/layout/AuthLayout";
import DashboardLayout from "./containers/layout/DashboardLayout";
import "./index.css";
import Login from "./pages/Login";
import News from "./pages/News";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Subsidiaries from "./pages/Subsidiaries";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import Team from "./pages/Team";
import AboutUsPage from "./pages/AboutUs";
import ContactUsPage from "./pages/ContactUs";
import SubsidiaryPageText from "./pages/SubsidiaryPage";
import LandingPageText from "./pages/Landing";
import DesktopOnly from "./pages/Mobile";
import MobileRedirect from "./components/MobileRedirect";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <MobileRedirect />
        <Routes>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Navigate to="/landing" replace />} />
            <Route path="/landing" element={<LandingPageText />} />
            <Route path="/news" element={<News />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/subsidiaries" element={<Subsidiaries />} />
            <Route path="/subsidiaryPage" element={<SubsidiaryPageText />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/aboutUs" element={<AboutUsPage />} />
            <Route path="/contactUs" element={<ContactUsPage />} />
            <Route path="/subsidiarypage" element={<SubsidiaryPageText />} />
          </Route>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
          </Route>
          <Route path="/desktop-only" element={<DesktopOnly />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
